import React from "react";
// import KidsVideo from "../../PicesForPages/Kids_Playing_in_park2.mp4";
import KidsVideo from "../../PicesForPages/Kids_Playing_in_park2.jpeg";
import FreeConsultation from "../Form/FreeConsultation";
import { Link } from "react-router-dom";

function purchase() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent purchasePagetopParent">
        {/* Video element */}
        {/* <video className="background-video" autoPlay loop muted>
          <source src={KidsVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}
        <img
          fetchPriority="high"
          loading="eager"
          src={KidsVideo}
          alt="RFamilyImage"
          className="background-video"
        />
        <div className="purchasetopBox purchasePagetopBox">
          {/* The existing Purchase span */}
          <span>Make a Purchase</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              For most people, purchasing a home is one of the most important
              financial decisions they will ever make. If you’re considering
              buying a home, you already know the process can be complex. With
              so many factors to consider, proper preparation is key. At{" "}
              <span className="brand_text">VIDHI MORTGAGE LLC</span> we are
              committed to helping you find{" "}
              <span className="purchaseBottomLeftContentBold">
                the loan solution that best fits your unique needs.
              </span>
            </span>
            <span className="purchaseBottomLeftHeader">Begin Your Journey</span>
            <ul className="purchaseBottomLeftUL">
              <li>
                Rent or Buy Decision Tool
                <br />
                <Link
                  to="/renting-versus-buying-calculator"
                  className="purchaseBottomLeftULLink"
                >
                  Click Here to evaluate the benefits of renting versus
                  purchasing.
                </Link>
              </li>
              <li>
                Required Documents Checklist
                <br />
                <Link to="/paper-work" className="purchaseBottomLeftULLink">
                  Click Here to view the documents you'll need.
                </Link>
              </li>
              <li>
                Ready to Secure Your Loan?
                <br />
                <Link
                  to="https://vidhimtg.my1003app.com"
                  className="purchaseBottomLeftULLink"
                >
                  Click Here to start your application.
                </Link>
              </li>
            </ul>
            <div className="purchaseBottomLeftButton">
              <Link
                to="https://vidhimortgage.my1003app.com/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </Link>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default purchase;
